<script setup lang="ts">
import type { ExperienceQuality, IntroMode } from '../../lib/experience'
import BootSequence from './BootSequence.vue'
import HeroScene from './HeroScene.vue'

defineProps<{
  quality: ExperienceQuality
  introMode: IntroMode
  introComplete: boolean
  reducedMotion: boolean
}>()

defineEmits<{
  skip: []
}>()
</script>

<template>
  <section id="top" class="hero-section" aria-labelledby="hero-title">
    <div class="hero-section__depth depth--far" aria-hidden="true">
      <span v-for="index in 14" :key="index" :style="{ '--index': index }" />
    </div>
    <div class="hero-section__grid" aria-hidden="true" />
    <div class="hero-section__halo" aria-hidden="true" />
    <div class="hero-section__foreground" aria-hidden="true">
      <i v-for="index in 7" :key="index" :style="{ '--index': index }" />
      <span>0x26 / CORE_FIELD</span>
      <span>DEPTH SIGNAL · ACTIVE</span>
    </div>

    <div class="hero-section__content">
      <div class="hero-copy">
        <p class="eyebrow"><span>2026</span> 软件工程新生数字计划</p>
        <h1 id="hero-title">
          <span class="hero-title__se">SE</span>
          <span class="hero-title__universe">UNIVERSE</span>
        </h1>
        <p class="hero-copy__zh">软件工程新生数字宇宙</p>
        <p class="hero-copy__tagline">从第一行代码，构建一个世界</p>
        <p class="hero-copy__intro">
          软件工程不止于写下代码。它把想法、系统、协作与真实世界连接起来。
        </p>
        <div class="hero-copy__actions">
          <a class="primary-action magnetic-action" href="#lifecycle" data-pointer-depth="magnetic">
            <span>进入数字宇宙</span>
            <i aria-hidden="true">↘</i>
          </a>
          <span class="hero-copy__system">
            <i aria-hidden="true" />
            CORE ONLINE · {{ quality.toUpperCase() }}
          </span>
        </div>
      </div>

      <HeroScene :quality="quality" :reduced-motion="reducedMotion" />
    </div>

    <div class="hero-section__scroll" aria-hidden="true">
      <span>SCROLL TO DECOMPOSE</span>
      <i />
    </div>
    <div class="hero-section__chapter" aria-hidden="true">
      <span>CHAPTER</span>
      <strong>00</strong>
    </div>
    <BootSequence :mode="introMode" :complete="introComplete" @skip="$emit('skip')" />
  </section>
</template>
